var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActsactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0834 9.16665H15.8334V5.83331C15.8334 5.39129 15.6578 4.96736 15.3452 4.6548C15.0326 4.34224 14.6087 4.16665 14.1667 4.16665H10.8334V2.91665C10.8334 2.36411 10.6139 1.83421 10.2232 1.44351C9.83246 1.05281 9.30255 0.833313 8.75002 0.833313C8.19749 0.833313 7.66758 1.05281 7.27688 1.44351C6.88618 1.83421 6.66669 2.36411 6.66669 2.91665V4.16665H3.33335C2.89133 4.16665 2.4674 4.34224 2.15484 4.6548C1.84228 4.96736 1.66669 5.39129 1.66669 5.83331V8.99998H2.91669C4.16669 8.99998 5.16669 9.99998 5.16669 11.25C5.16669 12.5 4.16669 13.5 2.91669 13.5H1.66669V16.6666C1.66669 17.1087 1.84228 17.5326 2.15484 17.8452C2.4674 18.1577 2.89133 18.3333 3.33335 18.3333H6.50002V17.0833C6.50002 15.8333 7.50002 14.8333 8.75002 14.8333C10 14.8333 11 15.8333 11 17.0833V18.3333H14.1667C14.6087 18.3333 15.0326 18.1577 15.3452 17.8452C15.6578 17.5326 15.8334 17.1087 15.8334 16.6666V13.3333H17.0834C17.6359 13.3333 18.1658 13.1138 18.5565 12.7231C18.9472 12.3324 19.1667 11.8025 19.1667 11.25C19.1667 10.6974 18.9472 10.1675 18.5565 9.77684C18.1658 9.38614 17.6359 9.16665 17.0834 9.16665Z",
    fill: "#004A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActsactive);
export default __webpack_public_path__ + "static/media/actsactive.58054e08bf19cde094344c341dbb89aa.svg";
export { ForwardRef as ReactComponent };